import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import Button from "../../atoms/Button";
import InputField from "../../atoms/InputField";
import { LOGIN } from "../../../api/apiAuth";

const LoginForm = () => {
    const navigate = useNavigate ();

    const validationSchema = Yup.object({
        email: Yup.string().email("El email no es valido").required("El email es requerido"),
        password: Yup.string().required("La contraseña es requerida"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const normalizedEmail = values.email.trim().toLowerCase();
            const newValues = { email:normalizedEmail, ...values};
            await LOGIN(newValues);
            toast.success("Sesión iniciada correctamente");
            navigate("/inicio");
        } catch (error) {
            if (error.response?.status === 401) {
                toast.error("Credenciales inválidas");
            } else {
                toast.error("Error al iniciar sesión");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return(
        <div className="relative">
            <FiUser className="absolute left-1/2 -translate-x-1/2 -top-14 bg-rs-azul p-2 rounded-full text-white" size={100}/>
            <Formik initialValues={{ email: "", password: "" }} onSubmit={handleSubmit} validationSchema={validationSchema}>
                {({ isSubmitting }) => (
                    <Form className="w-full grid gap-5 bg-white p-12 rounded-3xl">
                        <InputField name="email" type="text" label=" Correo electrónico"placeholder="Nombre de usuario" />
                        <InputField name="password" label="Contraseña" type="password" placeholder="Contraseña" />
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Iniciar sesión"} type="submit" bgColor="blue" disabled={isSubmitting}/>
                </Form>
                )}
            </Formik>
        </div>
    )
};

export default LoginForm;